export const INDUSTRY_IDS: Record<string, string> = {
  "Chiropractors": "2048",
  "Defense and Space Manufacturing": "1",
  "Optometrists": "2050",
  "Computer Hardware Manufacturing": "3",
  "Software Development": "4",
  "Technology, Information and Internet": "6",
  "Computer Networking Products": "5",
  "Transportation Equipment Manufacturing": "1029",
  "Physical, Occupational and Speech Therapists": "2054",
  "Semiconductor Manufacturing": "7",
  "Telecommunications": "8",
  "Law Practice": "9",
  "Legal Services": "10",
  "Housing Programs": "3081",
  "Business Consulting and Services": "11",
  "Biotechnology Research": "12",
  "Family Planning Centers": "2060",
  "Medical Practices": "13",
  "Transportation Programs": "3085",
  "Hospitals and Health Care": "14",
  "Utilities Administration": "3086",
  "Pharmaceutical Manufacturing": "15",
  "Outpatient Care Centers": "2063",
  "Veterinary Services": "16",
  "Medical Equipment Manufacturing": "17",
  "Space Research and Technology": "3089",
  "Motor Vehicle Parts Manufacturing": "1042",
  "Personal Care Product Manufacturing": "18",
  "Retail Apparel and Fashion": "19",
  "Sporting Goods Manufacturing": "20",
  "Tobacco Manufacturing": "21",
  "Medical and Diagnostic Laboratories": "2069",
  "Retail Groceries": "22",
  "Food and Beverage Manufacturing": "23",
  "Oil Extraction": "3095",
  "Computers and Electronics Manufacturing": "24",
  "Natural Gas Extraction": "3096",
  "Manufacturing": "25",
  "Furniture and Home Furnishings Manufacturing": "26",
  "Home Health Care Services": "2074",
  "Retail": "27",
  "Embedded Software Products": "3099",
  "Entertainment Providers": "28",
  "Mobile Computing Software Products": "3100",
  "Gambling Facilities and Casinos": "29",
  "Ambulance Services": "2077",
  "Desktop Computing Software Products": "3101",
  "IT System Custom Software Development": "3102",
  "Travel Arrangements": "30",
  "IT System Operations and Maintenance": "3103",
  "Hospitality": "31",
  "IT System Installation and Disposal": "3104",
  "Restaurants": "32",
  "IT System Training and Support": "3105",
  "Hospitals": "2081",
  "Spectator Sports": "33",
  "IT System Data Services": "3106",
  "Food and Beverage Services": "34",
  "IT System Testing and Evaluation": "3107",
  "Movies, Videos, and Sound": "35",
  "Broadcast Media Production and Distribution": "36",
  "Museums, Historical Sites, and Zoos": "37",
  "Artists and Writers": "38",
  "Performing Arts": "39",
  "Recreational Facilities": "40",
  "Banking": "41",
  "Nursing Homes and Residential Care Facilities": "2091",
  "Insurance": "42",
  "Financial Services": "43",
  "Real Estate": "44",
  "Investment Banking": "45",
  "Investment Management": "46",
  "Accounting": "47",
  "Construction": "48",
  "Wholesale Building Materials": "49",
  "Architecture and Planning": "50",
  "Civil Engineering": "51",
  "Internet News": "3124",
  "Aviation and Aerospace Component Manufacturing": "52",
  "Blogs": "3125",
  "Motor Vehicle Manufacturing": "53",
  "Interior Design": "3126",
  "Chemical Manufacturing": "54",
  "Social Networking Platforms": "3127",
  "Machinery Manufacturing": "55",
  "Household and Institutional Furniture Manufacturing": "1080",
  "Business Intelligence Platforms": "3128",
  "Mining": "56",
  "Business Content": "3129",
  "Oil and Gas": "57",
  "Shipbuilding": "58",
  "Utilities": "59",
  "Mobile Gaming Apps": "3131",
  "Textile Manufacturing": "60",
  "Internet Publishing": "3132",
  "Paper and Forest Product Manufacturing": "61",
  "Media and Telecommunications": "3133",
  "Railroad Equipment Manufacturing": "62",
  "Blockchain Services": "3134",
  "Farming": "63",
  "Services for the Elderly and Disabled": "2112",
  "Ranching": "64",
  "Dairy Product Manufacturing": "65",
  "Office Furniture and Fixtures Manufacturing": "1090",
  "Fisheries": "66",
  "Community Services": "2115",
  "Primary and Secondary Education": "67",
  "Higher Education": "68",
  "Education Administration Programs": "69",
  "Research Services": "70",
  "Mattress and Blinds Manufacturing": "1095",
  "Armed Forces": "71",
  "Legislative Offices": "72",
  "Administration of Justice": "73",
  "International Affairs": "74",
  "Emergency and Relief Services": "2122",
  "Government Administration": "75",
  "Executive Offices": "76",
  "Law Enforcement": "77",
  "Vocational Rehabilitation Services": "2125",
  "Public Safety": "78",
  "Public Policy Offices": "79",
  "Advertising Services": "80",
  "Child Day Care Services": "2128",
  "Newspaper Publishing": "81",
  "Performing Arts and Spectator Sports": "2130",
  "Book and Periodical Publishing": "82",
  "Printing Services": "83",
  "Information Services": "84",
  "Libraries": "85",
  "Theater Companies": "2133",
  "Environmental Services": "86",
  "Freight and Package Transportation": "87",
  "Dance Companies": "2135",
  "Individual and Family Services": "88",
  "Religious Institutions": "89",
  "Civic and Social Organizations": "90",
  "Circuses and Magic Shows": "2139",
  "Truck Transportation": "92",
  "Warehousing and Storage": "93",
  "Sports Teams and Clubs": "2142",
  "Airlines and Aviation": "94",
  "Maritime Transportation": "95",
  "IT Services and IT Consulting": "96",
  "Market Research": "97",
  "Public Relations and Communications Services": "98",
  "Design Services": "99",
  "Computer Games": "109",
  "Events Services": "110",
  "Retail Art Supplies": "111",
  "Museums": "2159",
  "Appliances, Electrical, and Electronics Manufacturing": "112",
  "Online Audio and Video Media": "113",
  "Wholesale Furniture and Home Furnishings": "1137",
  "Historical Sites": "2161",
  "Nanotechnology Research": "114",
  "Retail Art Dealers": "3186",
  "Translation and Localization": "108",
  "Musicians": "115",
  "Zoos and Botanical Gardens": "2163",
  "Defense & Space": "3187",
  "Transportation, Logistics, Supply Chain and Storage": "116",
  "Veterinary": "3188",
  "Plastics Manufacturing": "117",
  "Computer and Network Security": "118",
  "Political Organizations": "107",
  "Non-profit Organizations": "100",
  "Fundraising": "101",
  "Strategic Management Services": "102",
  "Writing and Editing": "103",
  "Staffing and Recruiting": "104",
  "Wholesale Motor Vehicles and Parts": "1128",
  "Venture Capital and Private Equity Principals": "106",
  "Professional Training and Coaching": "105",
  "Cosmetics": "3189",
  "Apparel & Fashion": "3190",
  "Wireless Services": "119",
  "Amusement Parks and Arcades": "2167",
  "Consumer Electronics": "3191",
  "Alternative Dispute Resolution": "120",
  "Consumer Goods": "3192",
  "Security and Investigations": "121",
  "Furniture": "3193",
  "Leisure, Travel & Tourism": "3194",
  "Food & Beverages": "3195",
  "Wellness and Fitness Services": "124",
  "Fine Art": "3196",
  "Alternative Medicine": "125",
  "Building Materials": "3197",
  "Media Production": "126",
  "Automotive": "3198",
  "Animation and Post-production": "127",
  "Dairy": "3199",
  "Leasing Non-residential Real Estate": "128",
  "Education Management": "3200",
  "Capital Markets": "129",
  "Wholesale Photography Equipment and Supplies": "1153",
  "Public Policy": "3201",
  "Think Tanks": "130",
  "Wholesale": "133",
  "Fire Protection": "3070",
  "Dentists": "2045",
  "Correctional Institutions": "3068",
  "Courts of Law": "3065",
  "Physicians": "2040",
  "Language Schools": "2029",
  "Household Appliance Manufacturing": "1005",
  "Fine Arts Schools": "2025",
  "Flight Training": "2020",
  "Cosmetology and Barber Schools": "2019",
  "Technical and Vocational Training": "2018",
  "Secretarial Schools": "2012",
  "Magnetic and Optical Media Manufacturing": "994",
  "Measuring and Control Instrument Manufacturing": "983",
  "Sports and Recreation Instruction": "2027",
  "Electric Lighting Equipment Manufacturing": "998",
  "Education": "1999",
  "Communications Equipment Manufacturing": "964",
  "Waste Collection": "1981",
  "Janitorial Services": "1965",
  "Waste Treatment and Disposal": "1986",
  "Security Guards and Patrol Services": "1956",
  "Metalworking Machinery Manufacturing": "928",
  "Collection Agencies": "1938",
  "Office Administration": "1916",
  "Professional Organizations": "1911",
  "Landscaping Services": "2934",
  "Industry Associations": "1909",
  "Metal Treatments": "883",
  "Holding Companies": "1905",
  "Turned Products and Fastener Manufacturing": "876",
  "Spring and Wire Product Manufacturing": "873",
  "Construction Hardware Manufacturing": "871",
  "Boilers, Tanks, and Shipping Container Manufacturing": "861",
  "Architectural and Structural Metal Manufacturing": "852",
  "Cutlery and Handtool Manufacturing": "849",
  "Fabricated Metal Products": "840",
  "Marketing Services": "1862",
  "Primary Metal Manufacturing": "807",
  "Abrasives and Nonmetallic Minerals Manufacturing": "799",
  "Lime and Gypsum Products Manufacturing": "794",
  "Professional Services": "1810",
  "Glass Product Manufacturing": "779",
  "Commercial and Industrial Equipment Rental": "1798",
  "Rubber Products Manufacturing": "763",
  "Clay and Refractory Products Manufacturing": "773",
  "Equipment Rental Services": "1779",
  "Real Estate Agents and Brokers": "1770",
  "Wood Product Manufacturing": "784",
  "Plastics and Rubber Product Manufacturing": "743",
  "Consumer Goods Rental": "1786",
  "Leasing Residential Real Estate": "1759",
  "Soap and Cleaning Product Manufacturing": "727",
  "Trusts and Estates": "1750",
  "Pension Funds": "1745",
  "Insurance and Employee Benefit Funds": "1743",
  "Funds and Trusts": "1742",
  "Paint, Coating, and Adhesive Manufacturing": "722",
  "Claims Adjusting, Actuarial Services": "1738",
  "Insurance Agencies and Brokerages": "1737",
  "Agricultural Chemical Manufacturing": "709",
  "Artificial Rubber and Synthetic Fiber Manufacturing": "703",
  "Insurance Carriers": "1725",
  "Cable and Satellite Programming": "1641",
  "Women's Handbag Manufacturing": "625",
  "Fashion Accessories Manufacturing": "615",
  "Telecommunications Carriers": "1644",
  "Radio and Television Broadcasting": "1633",
  "Sheet Music Publishing": "1625",
  "Credit Intermediation": "1673",
  "Sound Recording": "1623",
  "Apparel Manufacturing": "598",
  "Periodical Publishing": "1600",
  "Movies and Sound Recording": "1611",
  "Book Publishing": "1602",
  "Technology, Information and Media": "1594",
  "Distilleries": "564",
  "Leather Product Manufacturing": "616",
  "Satellite Telecommunications": "1649",
  "Postal Services": "1573",
  "Meat Products Manufacturing": "521",
  "Sightseeing Transportation": "1532",
  "Seafood Product Manufacturing": "528",
  "Fruit and Vegetable Preserves Manufacturing": "504",
  "Sugar and Confectionery Product Manufacturing": "495",
  "Shuttles and Special Needs Transportation Services": "1517",
  "Baked Goods Manufacturing": "529",
  "Pipeline Transportation": "1520",
  "School and Employee Bus Services": "1512",
  "Taxi and Limousine Services": "1505",
  "Breweries": "562",
  "Animal Feed Manufacturing": "481",
  "Urban Transit Services": "1497",
  "Building Finishing Contractors": "460",
  "Ground Passenger Transportation": "1495",
  "Interurban and Rural Bus Services": "1504",
  "Building Equipment Contractors": "453",
  "Wineries": "2500",
  "Utility System Construction": "419",
  "Data Infrastructure and Analytics": "2458",
  "Residential Building Construction": "408",
  "Nonresidential Building Construction": "413",
  "Retail Recyclable Materials & Used Merchandise": "1431",
  "Electrical Equipment Manufacturing": "2468",
  "Highway, Street, and Bridge Construction": "431",
  "Steam and Air-Conditioning Supply": "404",
  "Retail Florists": "1423",
  "Natural Gas Distribution": "397",
  "Water, Waste, Steam, and Air Conditioning Services": "398",
  "Building Construction": "406",
  "Water Supply and Irrigation Systems": "400",
  "Retail Office Supplies and Gifts": "1424",
  "Biomass Electric Power Generation": "390",
  "Geothermal Electric Power Generation": "389",
  "Environmental Quality Programs": "388",
  "Solar Electric Power Generation": "387",
  "Nuclear Electric Power Generation": "386",
  "Fossil Fuel Electric Power Generation": "385",
  "Retail Books and Printed News": "1409",
  "Electric Power Generation": "383",
  "Nonmetallic Mineral Mining": "356",
  "Hydroelectric Power Generation": "384",
  "Retail Musical Instruments": "1407",
  "Electric Power Transmission, Control, and Distribution": "382",
  "Operations Consulting": "2401",
  "Retail Gasoline": "1370",
  "Metal Ore Mining": "345",
  "Military and International Affairs": "2391",
  "Coal Mining": "341",
  "Retail Health and Personal Care Products": "1359",
  "Oil, Gas, and Mining": "332",
  "Economic Programs": "2375",
  "Conservation Programs": "2368",
  "Food and Beverage Retail": "1339",
  "Public Assistance Programs": "2360",
  "Air, Water, and Waste Program Management": "2366",
  "Housing and Community Development": "2369",
  "Health and Human Services": "2353",
  "Retail Building Materials and Garden Equipment": "1324",
  "Retail Furniture and Home Furnishings": "1309",
  "Retail Motor Vehicles": "1292",
  "Retail Appliances, Electrical, and Electronic Equipment": "1319",
  "Community Development and Urban Planning": "2374",
  "Household Services": "2318",
  "Internet Marketplace Platforms": "1285",
  "Ranching and Fisheries": "256",
  "Wholesale Alcoholic Beverages": "1267",
  "Wholesale Petroleum and Petroleum Products": "1262",
  "Pet Services": "2282",
  "Wholesale Chemical and Allied Products": "1257",
  "Laundry and Drycleaning Services": "2272",
  "Personal Care Services": "2259",
  "Footwear and Leather Goods Repair": "2255",
  "Personal and Laundry Services": "2258",
  "Wholesale Footwear": "1230",
  "Wholesale Raw Farm Products": "1250",
  "Wholesale Food and Beverage": "1231",
  "Reupholstery and Furniture Repair": "2253",
  "Commercial and Industrial Machinery Maintenance": "2247",
  "Wholesale Apparel and Sewing Supplies": "1222",
  "Wholesale Drugs and Sundries": "1221",
  "Electronic and Precision Equipment Maintenance": "2240",
  "Wholesale Paper Products": "1212",
  "Death Care Services": "3258",
  "Energy Technology": "3259",
  "Funeral Services": "3257",
  "Fuel Cell Manufacturing": "3255",
  "Wholesale Luxury Goods and Jewelry": "1208",
  "Smart Meter Manufacturing": "3254",
  "Farming, Ranching, Forestry": "201",
  "Climate Data and Analytics": "3252",
  "Wholesale Recyclable Materials": "1206",
  "Regenerative Design": "3256",
  "Vehicle Repair and Maintenance": "2226",
  "Climate Technology Product Manufacturing": "3251",
  "Retail Pharmacies": "3250",
  "Surveying and Mapping Services": "3249",
  "Robot Manufacturing": "3247",
  "Accessible Architecture and Design": "3246",
  "Robotics Engineering": "3248",
  "Accessible Hardware Manufacturing": "3245",
  "Digital Accessibility Services": "3244",
  "Services for Renewable Energy": "3243",
  "Engineering Services": "3242",
  "Bars, Taverns, and Nightclubs": "2217",
  "Paper & Forest Products": "3239",
  "Repair and Maintenance": "2225",
  "Renewable Energy Equipment Manufacturing": "3241",
  "Renewable Energy Power Generation": "3240",
  "Biotechnology": "3238",
  "Entertainment": "3237",
  "Maritime": "3236",
  "Caterers": "2212",
  "Computer Hardware": "3235",
  "Computer Networking": "3234",
  "Mobile Food Services": "2214",
  "Alternative Fuel Vehicle Manufacturing": "3253",
  "Research": "3233",
  "Information Technology & Services": "3231",
  "Tobacco": "3228",
  "Design": "3227",
  "Warehousing": "3229",
  "Aviation & Aerospace": "3226",
  "Philanthropy": "3230",
  "Wholesale Hardware, Plumbing, Heating Equipment": "1178",
  "Food Production": "3224",
  "Packaging & Containers": "3223",
  "Sporting Goods": "3225",
  "Transportation/Trucking/Railroad": "3222",
  "Horticulture": "150",
  "Government Relations": "3232",
  "Mechanical Or Industrial Engineering": "3221",
  "Wine & Spirits": "3220",
  "Commercial Real Estate": "3219",
  "Government Relations Services": "148",
  "Wholesale Machinery": "1187",
  "Bed-and-Breakfasts, Hostels, Homestays": "2197",
  "Wholesale Appliances, Electrical, and Electronics": "1171",
  "Automation Machinery Manufacturing": "147",
  "Semiconductors": "3218",
  "Hotels and Motels": "2194",
  "Packaging and Containers Manufacturing": "146",
  "Medical Device": "3217",
  "Glass, Ceramics and Concrete Manufacturing": "145",
  "Industrial Automation": "3216",
  "Renewable Energy Semiconductor Manufacturing": "144",
  "Animation": "3215",
  "Retail Luxury Goods and Jewelry": "143",
  "Wholesale Metals and Minerals": "1166",
  "Beverage Manufacturing": "142",
  "International Trade and Development": "141",
  "Graphic Design": "140",
  "Online Media": "3214",
  "Accommodation and Food Services": "2190",
  "Luxury Goods & Jewelry": "3212",
  "Mental Health Care": "139",
  "Human Resources": "3210",
  "Import & Export": "3209",
  "Renewables & Environment": "3213",
  "Business Supplies & Equipment": "3211",
  "Human Resources Services": "137",
  "Photography": "136",
  "Health, Wellness & Fitness": "3207",
  "Outsourcing/Offshoring": "3206",
  "Retail Office Equipment": "138",
  "Industrial Machinery Manufacturing": "135",
  "Music": "3205",
  "Wholesale Computer Equipment": "1157",
  "E-learning": "3208",
  "Skiing Facilities": "2181",
  "Arts & Crafts": "3204",
  "Program Development": "3203",
  "Philanthropic Fundraising Services": "131",
  "E-Learning Providers": "132",
  "Wholesale Import and Export": "134",
  "Non-profit Organization Management": "3202",
  "Golf Courses and Country Clubs": "2179",
};

export const getIndustryId = (name: string): string | undefined => {
  const id = INDUSTRY_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for industry: "${name}" - using text search fallback`);
  }
  return id;
};

